import React, { useState } from 'react';
import DiscipleNotes from './DiscipleNotes';

const MentoringNotesSection = ({ 
  discipleId, 
  userAppID, 
  onNoteAdded,
  showArchived
}) => {
  const handleNoteAdded = () => {
    console.log('🔵 MentoringNotesSection - Note added');
    if (onNoteAdded) {
      console.log('🔵 MentoringNotesSection - Calling parent onNoteAdded');
      onNoteAdded();
    } else {
      console.warn('🔵 MentoringNotesSection - No onNoteAdded handler provided');
    }
  };

  console.log('🔵 MentoringNotesSection - Rendering with props:', { 
    discipleId, 
    userAppID, 
    hasOnNoteAdded: !!onNoteAdded 
  });

  return (
    <DiscipleNotes 
      discipleId={discipleId}
      userAppID={userAppID}
      onNoteAdded={handleNoteAdded}
      showArchived={showArchived}
    />
  );
};

export default MentoringNotesSection; 